import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
  setImaOperations: ["operations"]
});

/**
 * Handlers
 */
const INITIAL_STATE = {
  operations: ["B"]
};

const setImaOperations = (state = INITIAL_STATE, action) => {
  const { operations } = action;
  return {
    ...state,
    operations
  };
};

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
  [Types.SET_IMA_OPERATIONS]: setImaOperations
});
